import { render } from "./MyPersonInfo.vue?vue&type=template&id=37c112ae"
import script from "./MyPersonInfo.vue?vue&type=script&lang=js"
export * from "./MyPersonInfo.vue?vue&type=script&lang=js"

import "./MyPersonInfo.vue?vue&type=style&index=0&id=37c112ae&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__